import { UserContact } from "../Contact/user-contact"
import { ModulesManagerService } from "../Module/modules-manager.service"

export class Share {
    private id: number = 0
    private askId: number = 0
    private userId: number = 0
    private displayName: string = ""
    private email: string = ""
    
    constructor(private manager: ModulesManagerService, Data: any = null) {
        if (Data != null) {
            this.Hydrate(Data)
        }
    }

    async Hydrate(Data, UpdateAnnex = false) {
        // hydrate les setter 
        for (const [propertie, values] of Object.entries(Data))
            this[this.manager.Tool.minimilizeFirstChar(propertie)] = values

    }

    get Id() {
        return this.id
    }

    get AskId() {
        return this.askId
    }

    get UserId() {
        return this.userId
    }

    get DisplayName() {
        let resu = this.manager.GetListModuleData("UsersContacts", "", 0, {Email: this.email}) as Array<UserContact>
        return resu.length ? resu[0].DisplayName : this.manager.Trad.Parse(this.displayName)
    }

    get Email() {
        return this.email
    }

    navigateToContact() {
        this.manager.Navi.navigateTo(`contacts`, {email:this.email})
    }
}
